/* src/app/shared/components/question-type-dropdown/question-type-dropdown.component.scss */
.hide-list {
  display: none;
}
.show-list {
  display: block;
}
.question-types-dropdown-menu .dropdown-item {
  cursor: pointer;
  padding: 5px 10px;
}
.question-types-dropdown-menu .dropdown-item:hover {
  background: #007c91;
  color: white;
}
.question-types-dropdown-menu .list-items-container {
  height: 187px;
  overflow-y: auto;
}
.left-18 {
  left: 6px !important;
}
/*# sourceMappingURL=question-type-dropdown.component.css.map */
